import { takeLatest, call, put, select } from 'redux-saga/effects'
import { getFeedSettings, postFeedSettings } from '../../api/api'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import { UPDATE_EVENT_ATTENDANCE } from 'portal-modules/events/redux/modules/events'
import { addCustomContent } from 'portal-modules/common/redux/modules/customContent'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import { createSelector } from 'reselect'

// action types
export const RECEIVE_FEED_ITEMS = 'rp/feed/RECEIVE_FEED_ITEMS'
export const UPDATE_ITEM = 'rp/feed/UPDATE_ITEM'
export const REQUEST_FEED_ITEMS = 'rp/feed/REQUEST_FEED_ITEMS'
export const SAVE_FEED_SETTINGS = 'rp/feed/SAVE_FEED_SETTINGS'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_FEED_ITEMS:
      return { ...state, ...payload?.items }
    case UPDATE_ITEM:
      return {
        ...state,
        [payload.uid]: {
          ...state[payload.uid],
          ...payload,
        },
      }
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const updateItem = payload => ({ type: UPDATE_ITEM, payload })
export const requestItems = () => ({ type: REQUEST_FEED_ITEMS })
export const saveFeedSettings = payload => ({
  type: SAVE_FEED_SETTINGS,
  payload,
})

export function* requestFeed() {
  const {
    custom_ad,
    column_ads,
    custom_text = '',
    banner_ad,
  } = yield call(getFeedSettings)
  // add custom content if available
  if (custom_ad && Object.keys(custom_ad).length) {
    yield put(
      addCustomContent({
        feed: custom_text,
        custom_adv: custom_ad,
        column_ads,
        banner_ad,
      }),
    )
  }
}

export function* updateEventFeedItem({ payload }) {
  const feeds = yield select(({ feed }) => {
    return Object.keys(feed).length
  })

  if (Object.keys(feeds).length > 0) {
    yield put(
      updateItem({
        uid: `Event-${payload.id}`,
        ...payload,
      }),
    )
  }
}

export function* saveSettings({ payload }) {
  const { hiddenFeedTypes } = payload
  yield call(postFeedSettings, {
    include_events: !hiddenFeedTypes.includes('Event'),
    include_announcements: !hiddenFeedTypes.includes('Announcement'),
    include_ads: !hiddenFeedTypes.includes('Classified'),
  })
}

// function * updateClassfiedFeedItem ({ payload }) {
//   yield put(
//     updateItem({
//       uid: `ClassifiedAd-${payload.id}`,
//       ...payload
//     })
//   )
// }

export function* watchUpdateEventFeedItem() {
  yield takeLatest(
    [UPDATE_EVENT_ATTENDANCE],
    createRequestSaga(updateEventFeedItem, {
      key: 'feed',
      message: __('Updating attendance'),
      write: true,
    }),
  )
}

export function* watchFeed() {
  yield takeLatest(
    REQUEST_FEED_ITEMS,
    createRequestSaga(requestFeed, {
      key: 'feed',
      message: __('Loading feed items'),
    }),
  )
}

export function* watchSaveFeedSettings() {
  yield takeLatest(
    SAVE_FEED_SETTINGS,
    createRequestSaga(saveSettings, {
      key: 'feed',
      message: __('Settings successfully saved'),
      successMessage: __('Settings saved successfully!'),
      write: true,
    }),
  )
}

// function * watchUpdateClassifiedFeedItem () {
//   yield takeLatest(
//     [SET_CLASSIFIED_FAVORITE],
//     createRequestSaga(updateClassfiedFeedItem, {
//       key: 'feed',
//       message: 'Syncing updates',
//       write: true
//     })
//   )
// }

export const sagas = [
  watchFeed,
  watchUpdateEventFeedItem,
  watchSaveFeedSettings,
  // watchUpdateClassifiedFeedItem
]

// selectors
export const aggregateFeedItems = createSelector(
  ({ events, classifieds, announcements }) => ({
    events,
    classifieds,
    announcements,
  }),
  (state, items) => items,
  ({ events, classifieds }, items) => ({
    items: items.map(item => {
      switch (item.type) {
        case 'Event':
          return events[item.id]
        case 'Classified':
          return classifieds[item.id]

        default:
          return item
      }
    }),
  }),
)
